

// export default new ApiService();
import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
import multipart from "../user/mutlipart";

// 📄 Get All Tickets
export const getTickets = () => {
  return axios.get(`${API}ticket/tickets/`, {
    headers: authHeader()
  });
};

// 📄 Get Single Ticket by ID
export const getTicketById = (ticketId) => {
  return axios.get(`${API}ticket/tickets/${ticketId}/`, {
    headers: authHeader()
  });
};

// 📝 Create Ticket
export const createTicket = (ticketData) => {
  return axios.post(`${API}ticket/tickets/`, ticketData, {
    headers: authHeader()
  });
};

// ✏️ Update Ticket
export const updateTicket = (ticketId, ticketData) => {
  return axios.patch(`${API}ticket/tickets/${ticketId}/`, ticketData, {
    headers: authHeader()
  });
};

// ❌ Delete Ticket (Soft delete)
export const deleteTicket = (ticketId) => {
  return axios.delete(`${API}ticket/tickets/${ticketId}/`, {
    headers: authHeader()
  });
};

// 📊 Dashboard Stats
export const getDashboardStats = () => {
  return axios.get(`${API}ticket/dashboard/stats/`, {
    headers: authHeader()
  });
};





// 📎 Upload Ticket Attachment
export const uploadAttachment = (ticketId, file) => {
  if (!file) {
    throw new Error('No file provided for upload');
  }
  if (!ticketId) {
    throw new Error('No ticket ID provided for attachment upload');
  }
  const formData = new FormData();
  formData.append('file', file);
  formData.append('original_name', file.name); // Add the original_name field
  console.log('Uploading attachment:', {
    fileName: file.name,
    fileSize: file.size,
    fileType: file.type,
    ticketId: ticketId
  });
  return axios.post(`${API}ticket/tickets/${ticketId}/attachments/`, formData, {
    headers: multipart()
  });
};

// 📎 Upload Comment Attachment
export const uploadCommentAttachment = (commentId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  console.log('Uploading comment attachment:', {
    fileName: file.name,
    fileSize: file.size,
    fileType: file.type,
    commentId: commentId
  });

  return axios.post(`${API}ticket/comments/${commentId}/attachments/`, formData, {
    headers: {
      ...authHeader(),
      'Content-Type': 'multipart/form-data'
    },
    timeout: 30000
  });
};

// 📎 Get Ticket Attachments
export const getTicketAttachments = async (ticketId) => {
  if (!ticketId) {
    console.warn('No ticket ID provided for attachment fetch');
    return { data: [] };
  }

  const cleanTicketId = ticketId.toString().split('?')[0];
  console.log('Fetching attachments for ticket:', cleanTicketId);

  try {
    // Try direct attachments endpoint first
    try {
    //   const attachmentsResponse = await axios.get(`${API}ticket/tickets/${cleanTicketId}/attachments/`, {
    //     headers: authHeader(),
    //     params: {
    //       t: new Date().getTime() // Cache busting
    //     }
    //   });

    //   const attachments = attachmentsResponse.data?.data || attachmentsResponse.data || [];
    //   console.log('Fetched attachments from direct endpoint:', attachments);
    //   return { data: attachments };
    } catch (directError) {
    //   console.log('Direct attachments endpoint failed, trying ticket details endpoint');

      // Fallback: Get ticket details which might include attachments
      const ticketResponse = await axios.get(`${API}ticket/tickets/${cleanTicketId}/`, {
        headers: authHeader(),
        params: {
          t: new Date().getTime() // Cache busting
        }
      });

      const attachments = ticketResponse.data?.attachments || [];
      console.log('Fetched attachments from ticket details:', attachments);
      return { data: attachments };
    }
  } catch (error) {
    console.error('Error fetching attachments:', error);
    return { data: [] };
  }
};



// 📁 Categories and Subcategories
export const getCategories = () => {
  return axios.get(`${API}ticket/categories/`, {
    headers: authHeader()
  });
};

export const getSubcategories = (categoryId) => {
  return axios.get(`${API}ticket/categories/${categoryId}/subcategories/`, {
    headers: authHeader()
  });
};

// 🚀 Ticket Actions
export const escalateTicket = (ticketId) => {
  return axios.post(`${API}ticket/tickets/${ticketId}/escalate/`, {}, {
    headers: authHeader()
  });
};

export const resolveTicket = (ticketId) => {
  return axios.post(`${API}ticket/tickets/${ticketId}/resolve/`, {}, {
    headers: authHeader()
  });
};

export const closeTicket = (ticketId) => {
  return axios.post(`${API}ticket/tickets/${ticketId}/close/`, {}, {
    headers: authHeader()
  });
};

// 💬 Comments
export const getTicketComments = (ticketId) => {
  // Remove any cache busting parameters that might have been added incorrectly
  const cleanTicketId = ticketId.split('?')[0];
  return axios.get(`${API}ticket/tickets/${cleanTicketId}/comments/`, {
    headers: authHeader(),
    // Add cache busting parameter to prevent caching
    params: {
      t: new Date().getTime()
    }
  });
};

export const addTicketComment = (ticketId, commentData) => {
  return axios.post(`${API}ticket/tickets/${ticketId}/comments/`, commentData, {
    headers: authHeader()
  });
};


// 👤 Get Assignable Users
export const getAssignableUsers = (page = 1) => {
  return axios.get(`${API}ticket/ticket-users/?page=${page}`, {
    headers: authHeader()
  });
};

// 👇 Export as grouped service (optional)
const TicketService = {
  getTickets,
  getTicketById,
  createTicket,
  updateTicket,
  deleteTicket,
  getDashboardStats,
  uploadAttachment,
  uploadCommentAttachment,
  getTicketAttachments,
  getCategories,
  getSubcategories,
  escalateTicket,
  resolveTicket,
  closeTicket,
  getTicketComments,
  addTicketComment,
  getAssignableUsers,
};

export default TicketService;
